<template>
  <div>
    <el-select
      v-model="isMinuteOrHour"
      :size="size"
      placeholder="Tiempo"
      @change="OnminuteHourChange"
      :disabled="disabled"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "MinuteOurSelectoForTasks",
  props: {
    MinuteHour: {
      type: String,
      default: "h",
      required: true
    },
    size: {
      type: String,
      default: "mini",
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    FixedMinuteHour: {
      type: String,
      default: "h",
      required: false
    }
  },
  data() {
    return {
      options: [
        {
          value: "m",
          label: "Minutos"
        },
        {
          value: "h",
          label: "Horas"
        }
      ],
      isMinuteOrHour: "h"
    };
  },
  updated() {
    if (this.FixedMinuteHour === "m") {
      this.isMinuteOrHour = "m"; // this.MinuteHour;
    } else {
      this.isMinuteOrHour = "h"; // this.MinuteHour;
    }
  },
  mounted() {
    if (this.FixedMinuteHour === "m") {
      this.isMinuteOrHour = "m"; // this.MinuteHour;
    } else {
      this.isMinuteOrHour = "h"; // this.MinuteHour;
    }
  },
  created() {
    if (this.FixedMinuteHour === "m") {
      this.isMinuteOrHour = "m"; // this.MinuteHour;
    } else {
      this.isMinuteOrHour = "h"; // this.MinuteHour;
    }
  },
  methods: {
    OnminuteHourChange(event) {
      this.$emit("MinuteHoureChanged", event);
    }
  },
  watch: {
    MinuteHour(MinuteHour) {
      MinuteHour;
      if (this.FixedMinuteHour === "m") {
        this.isMinuteOrHour = "m"; // this.MinuteHour;
      } else {
        this.isMinuteOrHour = "h"; // this.MinuteHour;
      } // MinuteHour;
    }
  }
};
</script>
